import React from 'react';
import Language from './Language/Language';
import Os from './Os/Os';

import './Main.scss';
import useTitle from "../useTitle";

const Main = ( props ) => {

    useTitle( "Home | Kalihackz" );

    React.useEffect(() => {
        props.onLoad(20);
    }, []);

    return (
        <main className="main">
            <section className="main__content">
                <div className="main__text">
                <span style={{fontSize:"50px"}}>H</span>i 👋 <br/> I am Abir Ghosh . I use Kalihackz as my name on Gaming and Coding platforms.

I am a developer . I love to code in various languages like HTML5 , CSS3 , Javascript , Python3 , Java , C , C++ , etc.

You can see my all projects seperately by clicking on the Projects from the Navigation Bar.
                </div>
                <div className="main__quote">
                    <div className="quote">
                        "It's Impossible." said Pride.<br/>
                        "It's Risky." said Experience.<br/>
                        "It's Pointless." said Reason.<br/>
                        <br/>
                        If you really are a Hacker !<br/>
                        then Give it a Try!
                    </div>
                    <div className="quote">
                        Never underestimate the determination<br/>
                        of a kid who is time-rich and cash-poor.<br/><br/>
                        -Anonymous
                    </div>
                </div>
            </section>
            <section className="main__sidebar">
                <Language onLoad={props.onLoad} />
                <Os onLoad={props.onLoad} />
            </section>
        </main>
    );

}

export default Main;